export const examineTypeObj = {
  1: '指定成员',
  2: '上级',
  3: '角色',
  4: '发起人自选',
  5: '连续多级上级'
};

export const wayTypeObj = {
  1: '依次审批',
  2: '会签',
  3: '或签'
};
